import React from "react";
import {
  AppBar as MuiAppBar,
  Button,
  IconButton,
  Toolbar,
} from "@mui/material";
import {
  Menu as MenuIcon,
  ArrowCircleLeftSharp,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import "../../css/appbar.css";
import logoInitial from "../../images/logo.png";
import logoComplete from "../../images/logo-complete.png";
import { useWidth } from "../../../libs/hooks";
import { useNavigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { AppbarSection, UserAvatar } from "../../../libs/shared/components";

export const drawerWidth = 180;

const AppBarElement = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, small }) => ({
  height: `57px`,
  minHeight: `57px`,
  maxHeight: `57px`,
  zIndex: 999,
  background: `linear-gradient(
    180deg,
    rgba(11, 13, 11, 1) 0%,
    rgb(20, 28, 20) 35%,
    rgb(37, 60, 38) 100%
  )`,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: small === "true" ? 0 : drawerWidth,
    width: small === "true" ? "100%" : `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const outerTheme = createTheme({
  palette: {
    primary: {
      main: "#25D228",
    },
  },
});

export const AppBar = ({ authTokens, handleDrawerOpen, open }) => {
  const width = useWidth();
  const navigate = useNavigate();



  return (
    <React.Fragment>
      <AppBarElement
        position="fixed"
        open={open}
        small={width === "xs" ? true : false}
      >
        <Toolbar className="toolbar">
          <div>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                borderRadius: 2,
                color: "#fff",
                border: "1px solid gainsboro",
                height: 32,
                marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon sx={{ color: "#fff" }} />
            </IconButton>
            <ThemeProvider theme={outerTheme}>
              <Button
                onClick={() => navigate(-1)}
                size="large"
                color="primary"
                variant="outlined"
                sx={{
                  position: "relative",
                  left: open ? "-19px" : width === "xs" ? "-30px" : "-2px",
                  marginRight: "-50px",
                }}
              >
                <ArrowCircleLeftSharp sx={{ color: "#fff" }} />
              </Button>
            </ThemeProvider>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              flexWrap: "nowrap",
              alignItems: "center",
              gap: "10px",
              position: "relative",
            }}
          >
            {
              width === "xs" ? (
                <img src={logoInitial} alt="MALIMAX" className="logo-initial" />
              ) : (
                <img src={logoComplete} alt="MALIMAX" className="logo" />
              )
            }
            <AppbarSection open={open} width={width} />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              position: "relative",
              right: "-10px",
            }}
          >
            {/* <NotificationBell /> */}
            <UserAvatar />
          </div>
        </Toolbar>
      </AppBarElement>
    </React.Fragment>
  );
};
